module.exports = __webpack_public_path__ + "static/media/westside_thumb_even.7dfabcee.webp";